import { memoizeJ } from "@thi.ng/memoize";
export const truncate = memoizeJ((n, suffix = "") => (x) => x.length > n ? x.substr(0, n - suffix.length) + suffix : x);
/**
 * Alias for {@link truncate}
 */
export const truncateRight = truncate;
